<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="1001030501">
        <el-button type="primary" plain @click="() => toAlarmVehicleList()">报警车辆 {{alarmVehicleNum}}</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="1001030502">
        <el-button type="primary" plain @click="() => toEdit()"><i class="iconfont">&#xe6ab;</i>新增路径</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
<!--          <el-table-column type="selection" width="55" />-->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section  slot-scope="scope">
                <!-- 路径名称 -->
                <section v-if="scope.column.property === 'pathName'">
                  <span class="primary cur" @click="toEdit(scope.row.id)">{{scope.row[scope.column.property] }}</span>
                </section>
                <!-- 路径名称 end -->
                <!-- 绑定车辆数 -->
                <section v-else-if="scope.column.property === 'bundingVehicleNumber'">
                  <span v-if="scope.row.lineId">--</span>
                  <span v-else>{{scope.row[scope.column.property]!==null?scope.row[scope.column.property]:0}}</span>
                </section>
                <section v-else>{{scope.row[scope.column.property]}}</section>

              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="160"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    permpisions: '1001030503',
                    showCondition: true,
                    name: '删除',
                    event: () => toRemove(scope.row),
                  },
                  {
                    permpisions: '1001030504',
                    showCondition: !scope.row.lineId,
                    name: '绑定/查看车辆',
                    event: () => toVehicleDetail(scope.row),
                  },
                  {
                    permpisions: '1001030505',
                    showCondition: scope.row.lineId,
                    name: '客户线路档案',
                    event: () => toLineDetail(scope.row),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryPlanningInfoList,
  deletePlanningInfo,
  doQueryPathVehicleAlarmCount,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      alarmVehicleNum: 0, // 报警车辆数
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {prop: 'pathName', label: '路径名称'},
          {prop: 'pathOrigin', label: '路径起点'},
          {prop: 'pathEndPoint', label: '路径终点'},
          {prop: 'startDate', label: '开始时间'},
          {prop: 'endDate', label: '结束时间'},
          {prop: 'remark', label: '备注'},
          {prop: 'orgName', label: '适用部门'},
          {prop: 'bundingVehicleNumber', label: '绑定车辆数'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryPlanningInfoList,
    async handleSubSucc () {
      const res = await doQueryPathVehicleAlarmCount({
        pathName: this.searchBoxData.pathName,
        orgId: this.searchBoxData.orgId,
        startDate: this.searchBoxData.startDate,
        endDate: this.searchBoxData.endDate,
      });
      this.alarmVehicleNum = res;
    },
    toAlarmVehicleList () {
      const pathName = this.searchBoxData.pathName;
      this.jump({
        label: '报警车辆',
        url: `/manage/operate/track/pathPlanningAlarmVehicle${pathName ? '?pathName=' + encodeURIComponent(pathName) : ''}`,
        full: true,
      });
    },
    toVehicleDetail (item) {
      this.jump({
        label: '绑定/查看车辆',
        url: `/manage/operate/track/pathPlanningVehicleDetail?id=${item.id}&pathName=${encodeURIComponent(item.pathName)}`,
        // full: true,
      });
    },
    toLineDetail (item, type = '') {
      this.jump({
        label: type ? '审核线路' : '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.lineId}&type=${type}`,
        full: true,
      });
    },
    toEdit (id) {
      this.jump({
        label: id ? '查看路径' : '新增路径',
        url: `/manage/operate/track/pathPlanning/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async toRemove (item) {
      const confirmRes = await this.$confirm(`确定要删除【${item.pathName}】这条路径信息吗`, '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const res = await deletePlanningInfo({
          id: item.id,
        });
        if (!res.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
